/**
 * Chat group class
 */
export default class {
  constructor (data) {
    this.id = data._id
    this.name = data.name
    this.t = data.t
    this.msg = data.msg
    this.usersCount = data.usersCount
    this.u = data.u
    this.ts = data.ts
    this.ro = data.ro
    this.toUser = data.to_user
    this.default = data.default
    this.sysMes = data.sysMes
    this.lastMessage = data.lastMessage
    this.unread = ~~data.unread
    this.subscription = data.subscription
    this.members = data.members || []
    this.open = data.members === undefined ? false : data.subscription?.open // workaround bug with groups
    this.displayUsername = this.formatName()
    this.archived = !!data.archived
  }

  conversationColorScheme () {
    return 'blue-grey'
  }

  isCurrentUserParticipating (user) {
    return this.members?.some((member) => member?.username === user?.username)
  }

  isOwner () {
    return this.subscription?.roles?.includes('owner') === true
  }

  isHidden () {
    return this.open === false
  }

  isReadOnly () {
    return this.ro === true
  }

  isArchived () {
    return this.archived
  }

  contextMenus (currentUser) {
    let menus = []
    const ownerMenu = [
      { title: 'Delete', key: 'delete', icon: 'mdi-delete', color: this.conversationColorScheme() }
    ]
    const managerMemberMenu = [
      { title: 'Manage Members', key: 'manage_members', icon: 'mdi-account-group', color: this.conversationColorScheme() }
    ]
    const archiveMenu = [
      { title: 'Archive', key: 'archive', icon: 'mdi-archive', color: this.conversationColorScheme() }
    ]
    const restoreMenu = [
      { title: 'Restore', key: 'restore', icon: 'mdi-restore', color: this.conversationColorScheme() }
    ]
    const leaveMenu = [
      { title: 'Leave', key: 'leave', icon: 'mdi-exit-to-app', color: this.conversationColorScheme() }
    ]
    const openMenu = [
      { title: 'Open', key: 'open', icon: 'mdi-eye', color: this.conversationColorScheme() }
    ]
    const closeMenu = [
      { title: 'Close', key: 'close', icon: 'mdi-eye-off', color: this.conversationColorScheme() }
    ]
    const seeMembers = [
      { title: 'See Members', key: 'see_members', icon: 'mdi-account-group', color: this.conversationColorScheme() }
    ]
    const renameMenu = [
      { title: 'Rename', key: 'rename', icon: 'mdi-rename-box', color: this.conversationColorScheme() }
    ]
    if (this.isOwner()) {
      if (this.archived) {
        menus = menus.concat(restoreMenu)
      } else {
        menus = menus.concat(archiveMenu)
        menus = menus.concat(managerMemberMenu)
        menus = menus.concat(renameMenu)
      }
      menus = menus.concat(ownerMenu)
    } else {
      menus = []
      if (this.isCurrentUserParticipating(currentUser)) {
        menus = menus.concat(leaveMenu)
        if (this.isHidden()) {
          menus = menus.concat(openMenu)
        } else {
          menus = menus.concat(closeMenu)
          menus = menus.concat(seeMembers)
        }
      } else {
        menus = menus.concat(seeMembers)
      }
    }
    return menus
  }

  icon (currentUser) {
    let icon = ''
    if (this.isCurrentUserParticipating(currentUser)) {
      icon = 'mdi-message'
      if (this.isOwner()) {
        icon = 'mdi-message-cog'
      }
      if (this.archived) {
        icon = 'mdi-message-text-lock'
      } else if (this.isHidden()) {
        icon = 'mdi-message-off'
      }
    } else {
      icon = 'mdi-message-outline'
      if (this.isOwner()) {
        icon = 'mdi-message-cog-outline'
      }
      if (this.archived) {
        icon = 'mdi-message-text-lock-outline'
      } else if (this.isHidden()) {
        icon = 'mdi-message-off-outline'
      }
    }
    return icon
  }

  iconColor () {
    return this.conversationColorScheme()
  }

  formatName () {
    if (this?.name.match('_')) {
      return this?.name.split('_')[1]
    } else {
      return this?.name
    }
  }
}
